import { Badge } from '@/components/shadcn/badge'
import { format } from 'd3-format'
import { ReactNode } from 'react'
import { ColumnMetadataConfig } from '../types-v4'
import { getMetadataForValue } from './getMetadataForValue'

/**
 * Renders a single badge
 */
export const RenderSingleBadge = ({
  value,
  metadata,
}: {
  value: string
  metadata?: ColumnMetadataConfig
}): ReactNode => {
  if (!metadata?.fields) {
    return (
      <Badge variant="outline" className="whitespace-nowrap bg-muted text-muted-foreground shadow">
        {value}
      </Badge>
    )
  }

  const metadataValue = getMetadataForValue(value, metadata.fields)
  const style = metadataValue.color ? { backgroundColor: metadataValue.color } : {}

  return (
    <Badge className="whitespace-nowrap" style={style}>
      {value}
    </Badge>
  )
}

/**
 * Renders an array of string badges
 */
export const RenderStringArrayBadges = ({ values }: { values: string[] }): ReactNode => {
  return (
    <div className="flex flex-wrap gap-1">
      {values.map((item) => (
        <Badge key={item} variant="outline" className="whitespace-nowrap bg-muted text-muted-foreground shadow">
          {item}
        </Badge>
      ))}
    </div>
  )
}

/**
 * Renders an array of number badges
 */
export const RenderNumberArrayBadges = ({ values, formatter }: { values: number[]; formatter?: string }): ReactNode => {
  return (
    <div className="flex flex-wrap gap-1">
      {values.map((item) => (
        <Badge key={item} variant="outline" className="whitespace-nowrap bg-muted text-muted-foreground shadow">
          {formatter ? format(formatter)(item) : item.toString()}
        </Badge>
      ))}
    </div>
  )
}
